import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useCancellationPlan } from 'src/context/billing';

import CancellationPrompt from './CancellationPrompt';
import DowngradeConfirmation from './DowngradeConfirmation';
import DowngradeInProgress from './DowngradeInProgress';

const NoActiveSolutionStepMap = {
  'show-cancellation-prompt': {
    title: 'We’re sorry to hear you may need to cancel...',
    description: 'What would you prefer to do?',
    component: CancellationPrompt,
  },
  'show-downgrade-confirmation': {
    title: 'Cancel your paid subscription?',
    description:
      'Are you sure? Continuing means your account will be scheduled for a downgrade. You will no longer have access to our services without re-activating your account.',
    component: DowngradeConfirmation,
  },
  'plan-downgrade-in-progress': {
    title: 'Plan downgrade in progress',
    description: 'The changes to your plan will be applied based on the terms of your account. ',
    component: DowngradeInProgress,
  },
};

const NoActiveSolutionsDialog = () => {
  const {
    ui: { step, setInitialData },
  } = useCancellationPlan();

  const isOpen = Object.keys(NoActiveSolutionStepMap).includes(step ?? '');

  const onOpenChange = (open: boolean) => {
    if (!open) setInitialData();
  };

  if (!step || !(step in NoActiveSolutionStepMap)) return null;

  const {
    title,
    description,
    component: ActiveComponent,
  } = NoActiveSolutionStepMap[step as keyof typeof NoActiveSolutionStepMap];

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[784px] gap-6">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <ActiveComponent />
      </DialogContent>
    </Dialog>
  );
};

export default NoActiveSolutionsDialog;
